import React, { useEffect, useState, useContext } from "react";
import CommentsView from "./CommentsView/CommentsView";
import CommentsHistoryView from "./CommentsHistoryView/CommentsHistoryView";
import { assembleViewCommentsData, structureComments } from "./Utilities";
import { ECLAddComment, ECLLoader } from "../../../index";
import { UserContext, ToastContext } from "../../../../utilities/contexts";
import { sourceOneRestRequest } from "../../../../utilities/requests";
import { translate } from "../../../../utilities/Translate";
import "./ECLComments.css";

// Switch views from comments-view to history-comments-view
// Take in a comment_section_id and query for comments
export default function ECLComments({ sectionId, projectId }) {
   const [comments, setComments] = useState([]);
   const [commentHistory, setCommentHistory] = useState([]);
   const [commentsView, setCommentsView] = useState(true);
   const userResults = useContext(UserContext);
   const addToast = useContext(ToastContext);
   // Functions that change views
   function handleCommentView() {
      setCommentsView(true);
   }
   function handleHistoryView() {
      setCommentsView(false);
   }
   // Buttons that change views
   const CommentsButton = (
      <button
         onClick={handleCommentView}
         className={`view-btn ${commentsView && "active"}`}
      >
         {translate("Comments")}
      </button>
   );
   const HistoryButton = (
      <button
         onClick={handleHistoryView}
         className={`view-btn ${!commentsView && "active"}`}
      >
         {translate("History")}
      </button>
   );

   async function getComments(sectionId) {
      const payload = {
         query_type: "comment_section",
         sectionId,
      };
      sourceOneRestRequest(payload)
         .then((res) => {
            setComments(assembleViewCommentsData(res));
            setCommentHistory(structureComments(res.history).reverse());
         })
         .catch((error) => {
            console.error(error);
            addToast(
               "There was an error requesting data from the server.",
               "error",
            );
         });
   }

   useEffect(() => {
      getComments(sectionId);
   }, []);

   if (!userResults) {
      return <ECLLoader />;
   }

   return (
      <section className="ecl-comments">
         <ECLAddComment sectionId={sectionId} getComments={getComments} />
         <CommentsView
            getComments={() => getComments(sectionId)}
            sectionId={sectionId}
            users={userResults.all}
            comments={comments}
            setComments={setComments}
            commentsView={commentsView}
            CommentButton={CommentsButton}
            HistoryButton={HistoryButton}
            projectId={projectId}
         />
         <CommentsHistoryView
            users={userResults.all}
            comments={commentHistory}
            setComments={setCommentHistory}
            commentsView={commentsView}
            CommentButton={CommentsButton}
            HistoryButton={HistoryButton}
            projectId={projectId}
         />
      </section>
   );
}
